// src/components/ConnectGuidelines.jsx
import React from "react";
import ReactDOM from "react-dom";
import Guideline from "./Guideline";

/**
 * ConnectGuidelines Component
 * ---------------------------
 * - Renders a single guideline into a target DOM node using React Portal.
 * - The target node is selected by the guideline's `name` property (class selector).
 * - Prevents unnecessary re-renders by memoizing the component.
 *
 * Props:
 * @param {Object} guideline - Guideline object containing metadata (e.g., name).
 * @param {Function} onCloseGuideline - Handler for closing the guideline.
 * @param {Function} onViewNext - Handler for moving to the next guideline.
 * @param {boolean} isLastItem - Flag indicating if this is the last guideline.
 */
function ConnectGuidelines({ guideline, onCloseGuideline, onViewNext, isLastItem }) {
  const { name } = guideline;

  // Query the DOM for the target element by class name
  const target = document.querySelector(`.${name}`);

  // If the target exists, render the Guideline component into it via a Portal
  if (target) {
    return ReactDOM.createPortal(
      <Guideline
        guideline={guideline}
        onViewNext={onViewNext}
        onCloseGuideline={onCloseGuideline}
        isLastItem={isLastItem}
      />,
      target
    );
  }

  // If no target element is found, render nothing
  return null;
}

// Memoize the component to avoid unnecessary re-renders when props don't change
export default React.memo(ConnectGuidelines);
